/*
 * @Author: ���� 371824572@qq.com
 * @Date: 2024-07-18 16:32:47
 * @LastEditors: ���� 371824572@qq.com
 * @LastEditTime: 2024-07-19 16:02:33
 * @FilePath: \rencaiban-xcx-adminnew\src\api\RecruitmentTemplate\RecruitmentTemplate.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import * as api from '../api';
import axios from 'axios';
// import router from '../routerManuaConfig'
import Vue from 'vue';
let base = api.BaseApiUrl;

//获取全部微信用户
export const GetWxUserInfo = params => {
    return axios.get(`${base}/api/WxUserInfo/GetWxUserInfo`,  { params: params });
};
//更新微信用户
export const PutWxUserInfo = params => {
    return axios.put(`${base}/api/WxUserInfo/PutWxUserInfo`,  params);
};
//删除微信用户
export const DeleteWxUserInfo = params => {
    return axios.delete(`${base}/api/WxUserInfo/DeleteWxUserInfo`, { params: params });
};